(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("react"), require("prop-types"));
	else if(typeof define === 'function' && define.amd)
		define(["react", "prop-types"], factory);
	else {
		var a = typeof exports === 'object' ? factory(require("react"), require("prop-types")) : factory(root["react"], root["prop-types"]);
		for(var i in a) (typeof exports === 'object' ? exports : root)[i] = a[i];
	}
})(this, function(__WEBPACK_EXTERNAL_MODULE_react__, __WEBPACK_EXTERNAL_MODULE_prop_types__) {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 0);
/******/ })
/************************************************************************/
/******/ ({

/***/ "./src/components/AddToSlot/AddToSlot.jsx":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__("react");

var PureComponent = _react.PureComponent;

var _propTypes = __webpack_require__("prop-types");

var PropTypes = _interopRequireDefault(_propTypes).default;

var _slots = __webpack_require__("./src/services/slots/slots.jsx");

var addToSlot = _slots.addToSlot;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var AddToSlot = function (_PureComponent) {
  _inherits(AddToSlot, _PureComponent);

  function AddToSlot(props) {
    _classCallCheck(this, AddToSlot);

    var _this = _possibleConstructorReturn(this, (AddToSlot.__proto__ || Object.getPrototypeOf(AddToSlot)).call(this, props));

    var name = props.name,
        children = props.children;


    addToSlot(name, children);
    return _this;
  }

  _createClass(AddToSlot, [{
    key: 'render',
    value: function render() {
      return null;
    }
  }]);

  return AddToSlot;
}(PureComponent);

AddToSlot.propTypes = {
  name: PropTypes.oneOfType([PropTypes.string, PropTypes.number, PropTypes.symbol]).isRequired,

  children: PropTypes.node.isRequired
};

exports.default = AddToSlot;

/***/ }),

/***/ "./src/components/Aux/Aux.jsx":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__("react");

var React = _interopRequireDefault(_react).default;

var _propTypes = __webpack_require__("prop-types");

var PropTypes = _interopRequireDefault(_propTypes).default;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Aux = function Aux(_ref) {
  var children = _ref.children;
  return React.createElement(
    'div',
    null,
    children
  );
};

Aux.propTypes = {
  children: PropTypes.node.isRequired
};

exports.default = Aux;

/***/ }),

/***/ "./src/components/RenderSlot/RenderSlot.jsx":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__("react");

var PureComponent = _react.PureComponent;

var _propTypes = __webpack_require__("prop-types");

var PropTypes = _interopRequireDefault(_propTypes).default;

var _slots = __webpack_require__("./src/services/slots/slots.jsx");

var renderSlot = _slots.renderSlot;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var RenderSlot = function (_PureComponent) {
  _inherits(RenderSlot, _PureComponent);

  function RenderSlot() {
    _classCallCheck(this, RenderSlot);

    return _possibleConstructorReturn(this, (RenderSlot.__proto__ || Object.getPrototypeOf(RenderSlot)).apply(this, arguments));
  }

  _createClass(RenderSlot, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          name = _props.name,
          wrapper = _props.wrapper;


      return renderSlot(name, wrapper);
    }
  }]);

  return RenderSlot;
}(PureComponent);

RenderSlot.propTypes = {
  name: PropTypes.oneOfType([PropTypes.string, PropTypes.number, PropTypes.symbol]).isRequired,

  wrapper: PropTypes.oneOfType([PropTypes.node, PropTypes.func])
};

RenderSlot.defaultProps = {
  wrapper: null
};

exports.default = RenderSlot;

/***/ }),

/***/ "./src/decorators/route-decorator.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = route;

var _router = __webpack_require__("./src/services/router/router.jsx");

var addComponentRoute = _router.addComponentRoute;

var _routes = __webpack_require__("./src/services/routes/routes.js");

var getRoute = _routes.getRoute;
function route(routeId) {
  var exact = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

  return function (component) {
    var routeUrl = getRoute(routeId);

    addComponentRoute(routeId, routeUrl, component, exact);
  };
}

/***/ }),

/***/ "./src/decorators/slot-decorator.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.slot = slot;
exports.renderTo = renderTo;

var _slots = __webpack_require__("./src/services/slots/slots.jsx");

var addToSlot = _slots.addToSlot;
function slot() {}

function renderTo(slotId) {
  return function (target, propertyKey, descriptor) {
    addToSlot(slotId, descriptor.value);
  };
}

/***/ }),

/***/ "./src/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.AddToSlot = exports.RenderSlot = exports.renderSlot = exports.addToSlot = exports.getRoutesComponents = exports.addComponentRoute = exports.addRoute = exports.getRoute = exports.renderTo = exports.slot = exports.route = exports.Aux = undefined;

var _Aux = __webpack_require__("./src/components/Aux/Aux.jsx");

var Aux = _interopRequireDefault(_Aux).default;

var _RenderSlot = __webpack_require__("./src/components/RenderSlot/RenderSlot.jsx");

var RenderSlot = _interopRequireDefault(_RenderSlot).default;

var _AddToSlot = __webpack_require__("./src/components/AddToSlot/AddToSlot.jsx");

var AddToSlot = _interopRequireDefault(_AddToSlot).default;

var _routeDecorator = __webpack_require__("./src/decorators/route-decorator.js");

var route = _interopRequireDefault(_routeDecorator).default;

var _slotDecorator = __webpack_require__("./src/decorators/slot-decorator.js");

var slot = _slotDecorator.slot;
var renderTo = _slotDecorator.renderTo;

var _routes = __webpack_require__("./src/services/routes/routes.js");

var getRoute = _routes.getRoute;
var addRoute = _routes.addRoute;

var _router = __webpack_require__("./src/services/router/router.jsx");

var addComponentRoute = _router.addComponentRoute;
var getRoutesComponents = _router.getRoutesComponents;

var _slots = __webpack_require__("./src/services/slots/slots.jsx");

var addToSlot = _slots.addToSlot;
var renderSlot = _slots.renderSlot;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.Aux = Aux;
exports.route = route;
exports.slot = slot;
exports.renderTo = renderTo;
exports.getRoute = getRoute;
exports.addRoute = addRoute;
exports.addComponentRoute = addComponentRoute;
exports.getRoutesComponents = getRoutesComponents;
exports.addToSlot = addToSlot;
exports.renderSlot = renderSlot;
exports.RenderSlot = RenderSlot;
exports.AddToSlot = AddToSlot;

/***/ }),

/***/ "./src/services/router/router.jsx":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.addComponentRoute = addComponentRoute;
exports.getRoutesComponents = getRoutesComponents;

var _react = __webpack_require__("react");

var React = _interopRequireDefault(_react).default;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var routes = new Map();

// TODO: Use object attribute
function addComponentRoute(routeId, uri, component) {
  var exact = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;

  // TODO: Should we check uri instead of the routeId?
  if (routes.has(routeId)) {
    throw new TypeError('Given route "' + routeId + '" should be unique but it\'s already used.');
  }

  routes.set(routeId, { uri: uri, component: component, exact: exact });
}

function getRoutesComponents(Component) {
  var components = [];

  routes.forEach(function (_ref, routeId) {
    var uri = _ref.uri,
        component = _ref.component,
        exact = _ref.exact;

    components.push(React.createElement(Component, {
      key: routeId.toString(),
      path: uri,
      component: component,
      exact: exact
    }));
  });

  return components;
}

/***/ }),

/***/ "./src/services/routes/routes.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

exports.addRoute = addRoute;
exports.getRoute = getRoute;
var routesMap = new Map();

function addRoute(routeId, url) {
  if ((typeof routeId === 'undefined' ? 'undefined' : _typeof(routeId)) !== 'symbol') {
    console.warn('It\'s recommended to use Symbol(' + routeId + ') for naming the route id');
  }

  if (routesMap.has(routeId)) {
    throw new TypeError('Route with this id is already in use. Please use different route.');
  }

  routesMap.set(routeId, url);
}

function getRoute(routeId) {
  if ((typeof routeId === 'undefined' ? 'undefined' : _typeof(routeId)) !== 'symbol') {
    var routes = Array.from(routesMap.entries());

    throw new TypeError('You need to use defined name of the route. Possible routes are ' + routes);
  }

  if (!routesMap.has(routeId)) {
    throw new TypeError('Cannot find the route named "' + routeId + '"');
  }

  return routesMap.get(routeId);
}

/***/ }),

/***/ "./src/services/slots/slots.jsx":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.addToSlot = addToSlot;
exports.renderSlot = renderSlot;

var _react = __webpack_require__("react");

var React = _interopRequireDefault(_react).default;

var Component = _react.Component;
var PureComponent = _react.PureComponent;
var isValidElement = _react.isValidElement;

var _Aux = __webpack_require__("./src/components/Aux/Aux.jsx");

var Aux = _interopRequireDefault(_Aux).default;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var slots = new Map();

var createEmptySlot = function createEmptySlot() {
  for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
    args[_key] = arguments[_key];
  }

  return new (Function.prototype.bind.apply(Set, [null].concat(args)))();
};

var EmptyComponent = function EmptyComponent() {
  return null;
};
var emptySlot = createEmptySlot([EmptyComponent]);

function addToSlot(slotId, component) {
  if (typeof component !== 'function') {
    throw new TypeError('Given component must be a valid callback');
  }

  var slot = slots.has(slotId) ? slots.get(slotId) : createEmptySlot();

  console.debug('Slots: Adding new component to slot "' + slotId.toString() + '"');

  slot.add(component);

  slots.set(slotId, slot);
}

var isValidReactComponent = function isValidReactComponent(componentFactory) {
  var component = componentFactory();

  var isComponentInstance = Component.isPrototypeOf(component);
  var isPureComponentInstance = PureComponent.isPrototypeOf(component);
  var isComponentValidElement = isValidElement(component);
  var isEmptyComponent = componentFactory === EmptyComponent;

  return isComponentInstance || isPureComponentInstance || isComponentValidElement || isEmptyComponent;
};

function renderSlot(slotId) {
  var childrenWrapper = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

  var slot = slots.has(slotId) ? slots.get(slotId) : emptySlot;

  var components = [];

  slot.forEach(function (componentFactory) {
    if (!isValidReactComponent(componentFactory)) {
      throw new TypeError('Given component must be a valid React element');
    }

    var component = componentFactory();

    var useWrapper = Boolean(childrenWrapper);

    if (useWrapper && (isValidElement(childrenWrapper) || typeof childrenWrapper === 'function')) {
      component = childrenWrapper({ children: component });
    }

    components.push(component);
  });

  console.debug('Slots: Rendering slot "' + slotId.toString() + '" with ' + components.length + ' components in total');

  return React.createElement(
    Aux,
    null,
    components
  );
}

/***/ }),

/***/ 0:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__("./src/index.js");


/***/ }),

/***/ "prop-types":
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE_prop_types__;

/***/ }),

/***/ "react":
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE_react__;

/***/ })

/******/ });
});


// WEBPACK FOOTER //
// index.js